import React, {useState, useEffect} from 'react'

import {
    useHistory
} from 'react-router-dom'

import { 
    Auth,
} from 'aws-amplify'

import { 
    ComponentsDiv,
} from '../Styles/Pages/LogOutConfirmStyles'

import { 
    TopBackgroundDiv,
    BottomBackgroundDiv
} from '../Styles/BaseStyles'

import LogOutConfirmDisplay from '../Components/Display/LogOutConfirm'

import { 
    useSelector,
    useDispatch 
} from 'react-redux'

import { 
    reset as settingsSliceReset
} from '../Redux/Slices/SettingsSlice'

import { 
    reset as userSliceReset 
} from '../Redux/Slices/UserSlice'

function LogOutConfirm(props){
    let history = useHistory()

    const dispatch = useDispatch()

    const [load,setLoad] = useState(false)

    const storage = useSelector(state => state.user.storage)

    useEffect(() => {
        switch(storage){
            case 'localstorage':
                Auth.configure({storage: localStorage})
                break
            case 'sessionstorage':
                Auth.configure({storage: sessionStorage})
                break
            default:
                break
        }
        Auth.currentAuthenticatedUser().then(() => {
            history.push('/hub')
        })
        .catch(() => {
            dispatch(settingsSliceReset())
            dispatch(userSliceReset())
            setLoad(true)
        })
    }, [])

    var viewer = (
        <>
        </>
    )

    if(load){
        viewer = (
            <>
                <TopBackgroundDiv />
                <BottomBackgroundDiv />
                <ComponentsDiv>
                    <LogOutConfirmDisplay />
                </ComponentsDiv>
            </>
        )
    }

    return (
        <>
            {viewer}
        </>
    )
}

export default LogOutConfirm